import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Sorting } from '@saucelabs/ds-filters';

import constants from '../../constants';
import actions from '../../actions';
import selectors from '../../selectors';

const {
  DEVICE_SORT_MODES,
} = constants;

const sortModeOptions = [{
  label: 'Preferred First',
  value: DEVICE_SORT_MODES.PREFERRED_FIRST,
}, {
  label: 'Pinned First',
  value: DEVICE_SORT_MODES.PINNED_FIRST,
},
{
  label: 'A to Z',
  value: DEVICE_SORT_MODES.A_TO_Z,
}, {
  label: 'Z to A',
  value: DEVICE_SORT_MODES.Z_TO_A,
}];

const DeviceSortBar: React.FC = () => {
  const dispatch = useDispatch<ReduxDispatcher>();
  const { sortMode } = useSelector(selectors.mobileSelectionSelector);

  return (
    <Sorting
      data-qa="device-filter-bar-sorting"
      defaultSelected={sortMode}
      name="sortMode"
      onSelect={(selectedSortMode) => {
        dispatch(actions.sortDevices(selectedSortMode));
      }}
      options={sortModeOptions}
    />
  );
};

export default DeviceSortBar;
